<template>
  <div>
    <v-container
      fluid
      :class="{
        'mx-12': !mobile,
        'my-6': !mobile
      }"
    >
      <div
        :class="{
          'd-flex': true,
          'flex-row': !mobile,
          'flex-column': mobile,
          'mb-4': !mobile
        }"
      >
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-download-circle</v-icon>
          <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Jobs</p>
        </div>
        <div v-if="!mobile" class="flex-grow-1"></div>
      </div>
      <v-card v-if="isLoaded" elevation="0">
        <v-list three-line>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-link</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                ><b>{{ title }}</b> (Job:
                {{ asyncJob.jobId }})</v-list-item-title
              >
              <v-list-item-subtitle class="text-high-emphasis"
                >Status: {{ asyncJob.status }}</v-list-item-subtitle
              >
              <div v-if="!isCompleted">
                <v-progress-linear indeterminate />
              </div>
              <v-list-item-subtitle class="text-high-emphasis">
                {{ subtitle }}</v-list-item-subtitle
              >
            </v-list-item-content>
            <v-list-item-action>
              <small class="mb-4 text-high-emphasis opacity-60">{{
                formattedDateUpdated
              }}</small>
              <v-btn
                v-if="showDownloadIcon"
                icon
                :disabled="!isCompleted"
                @click="openResult(asyncJob)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
      <v-card v-else class="pa-4">
        <v-skeleton-loader
          type="list-item-two-line-avatar"
          class="mx-auto"
          width="400"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { TIMESTAMP_FORMAT } from '../util/date'

export default {
  data() {
    return {
      isLoaded: false,
      pollingInterval: null,
      asyncJob: {
        jobId: '',
        status: '',
        metadata: {},
        dateCreated: '',
        dateUpdated: '',
        type: '',
        result: {}
      }
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    asyncJobId() {
      return this.$route.params.id
    },
    progressBarValue() {
      switch (this.asyncJob.status) {
        case 'PENDING':
        default:
          return 25
        case 'IN_PROGRESS':
          return 75
        case 'COMPLETED':
          return 100
      }
    },
    title() {
      switch (this.asyncJob.type) {
        case 'GENERATE_SOA_LESSOR':
          return 'Generate SOA'
        case 'GENERATE_SOA_TENANT':
          return 'Generate SOA for Tenant'
        default:
          return 'N/A'
      }
    },
    subtitle() {
      if (this.asyncJob.metadata && this.asyncJob.metadata.tenant) {
        return `Tenant: ${this.asyncJob.metadata.tenant.username}`
      }
      return 'No available details'
    },
    formattedDateUpdated() {
      return dayjs(this.asyncJob.dateUpdated).format(TIMESTAMP_FORMAT)
    },
    isCompleted() {
      return this.asyncJob.status === 'COMPLETED'
    },
    showDownloadIcon() {
      return (
        this.asyncJob.result && this.asyncJob.result.type === 'DOWNLOAD_LINK'
      )
    }
  },
  mounted() {
    this.fetchAsyncJob().then(() => {
      this.isLoaded = true

      if (!this.isCompleted) {
        this.pollingInterval = setInterval(() => {
          this.checkClearInterval()
          this.fetchAsyncJob()
        }, 1000)
      }
    })
  },
  destroyed() {
    clearInterval(this.pollingInterval)
  },
  methods: {
    checkClearInterval() {
      if (this.isCompleted) {
        clearInterval(this.pollingInterval)
      }
    },
    async fetchAsyncJob() {
      const asyncJob = await this.$store.dispatch(
        'asyncJobs/fetchAsyncJob',
        this.asyncJobId
      )

      if (!asyncJob) {
        throw new Error('Failed to fetch async job')
      }

      this.asyncJob = {
        jobId: asyncJob.jobId,
        status: asyncJob.status,
        metadata: asyncJob.metadata,
        dateCreated: asyncJob.dateCreated,
        dateUpdated: asyncJob.dateUpdated,
        type: asyncJob.type,
        result: asyncJob.result
      }
    },
    openResult(asyncJob) {
      window.open(asyncJob.result.url)
    }
  }
}
</script>
